import { lang } from "../../assets/lang"
const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon


const delayHtmlFb = 
'<div class="form-group text-left mt-3">' +
  '<div class="control-label">' + lang.delay_html_label_typing_display + '</div>' +
  '<label class="mt-2">' +
    '<input type="checkbox" name="custom-switch-checkbox" class="custom-switch-input" id="delay-typing-on-display">' +
    '<span class="custom-switch-indicator"></span>' +
  '</label>' +
'</div>' +

'<div class="form-group text-left mt-2" id="delay-typing-on-display-group">' +
  '<label for="delay-delay-in-reply">' + lang.delay_html_label_delay_in_reply + '&nbsp; - &nbsp;<span id="delay-delay-text">0 ' + lang.delay_html_info_sec + '</span></label>' +
  '<input type="range" class="custom-range" id="delay-delay-in-reply" min="0" max="60" step="1" value="0" aria-describedby="delay-delay-in-reply-help" >' +
'</div>'

const delayHtmlIg = ''

export const delayHtml = instagram_bot_addon ? delayHtmlIg : delayHtmlFb;